export default __webpack_public_path__ + "static/media/kitchen.e895b636.svg";